/**
 * 项目使用前后端分离，为以后修改提供便利，所以在这里定义一些与服务器交互的常量，
 * 主要包括服务器地址，服务器端口，以及上下文根等
 */

// const profiles = "local"; //本地环境
// const profiles = "local_54"; //本地环境
// const profiles = "local_53"; //本地环境
// const profiles = "test"; //测试环境
// const profiles = "test_l"; //测试环境
const profiles = "release"; //正式发布环境


// 本地的服务配置
const local_config = {
    mallServerUrl: "http://localhost:8889",//商城服务地址，用来取停车场图片
    httpServerUrl: 'http://localhost:9999', //后台服务器地址
    webServerUrl: 'http://localhost:3000', //web服务器地址，即tomcat、nginx等提供网页资源请求的地址
    websocketUrl: 'ws://localhost:9999', //web socket的服务请求地址
    wechatAppId: 'wxdf61a9949d089a94' ,//微信服务号id
    barrier_img_url: "https://app.xm2auto.com:9012/"
}

// 测试环境的服务配置
const test_l_config = {
    httpServerUrl: 'http://10.200.141.15:8888', //后台服务器地址
    webServerUrl: 'http://10.200.141.15:3000', //web服务器地址，即tomcat、nginx等提供网页资源请求的地址
    websocketUrl: 'ws://10.200.141.15:8888', //web socket的服务请求地址
    wechatAppId: 'wxdf61a9949d089a94', //微信服务号id
}

// 测试环境的服务配置
const test_config = {
    httpServerUrl: 'http://117.29.164.86:8888', //后台服务器地址
    webServerUrl: 'http://117.29.164.86:3000', //web服务器地址，即tomcat、nginx等提供网页资源请求的地址
    websocketUrl: 'ws://117.29.164.86:8888', //web socket的服务请求地址
    wechatAppId: 'wxdf61a9949d089a94', //微信服务号id
}

// 本地的服务配置
// const local_53_config = {
//     httpServerUrl: 'http://172.26.174.53:8888', //后台服务器地址
//     webServerUrl: 'http://172.26.174.53:3000', //web服务器地址，即tomcat、nginx等提供网页资源请求的地址
//     websocketUrl: 'ws://172.26.174.53:8888', //web socket的服务请求地址
//     wechatAppId: 'wxdf61a9949d089a94', //微信服务号id
// }

// 本地的服务配置
const local_54_config = {
    httpServerUrl: 'http://172.26.174.54:8888', //后台服务器地址
    webServerUrl: 'http://172.26.174.54:3000', //web服务器地址，即tomcat、nginx等提供网页资源请求的地址
    websocketUrl: 'ws://172.26.174.54:8888', //web socket的服务请求地址
    wechatAppId: 'wxdf61a9949d089a94', //微信服务号id
}

// 正式发布环境的服务配置
const release_config = {
    mallServerUrl: "https://mall.xm2auto.com:8889",//商城服务地址，用来取停车场图片
    httpServerUrl: 'https://app.xm2auto.com:8888', //后台服务器地址
    webServerUrl: 'https://app.xm2auto.com', //web服务器地址，即tomcat、nginx等提供网页资源请求的地址
    websocketUrl: 'wss://app.xm2auto.com:8888', //web socket的服务请求地址
    wechatAppId: 'wxc42ab0e05de97be9', //微信服务号id
    barrier_img_url: "https://app.xm2auto.com:9012/"
}


let server = profiles === "release" ? release_config : profiles === "local_54" ? local_54_config
    : profiles === "test" ? test_config : profiles === "test_l" ? test_l_config : local_config;

export default server;
